import React, { useEffect, useState } from 'react'
import { db } from '../../firebase';
import moment from 'moment';
import "./AdminOrders.css"
import { NumericFormat } from 'react-number-format';
import FilterAltOutlinedIcon from '@mui/icons-material/FilterAltOutlined';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import AutorenewOutlinedIcon from '@mui/icons-material/AutorenewOutlined';
import { Button } from 'react-bootstrap';
import { Link } from 'react-router-dom/cjs/react-router-dom';

const AdminOrders = () => {
  const [orders, setOrders] = useState([])
  const [loading, setLoading] = useState(false)

  async function getOrders() {
    setLoading(true)
    try {
      const usersSnapshot = await db.collection("users").get();

      if (usersSnapshot.empty) {
        setLoading(false)
        return;
      }

      let orderData = []
      for (const userDoc of usersSnapshot.docs) {
        const userId = userDoc.id;
        const ordersSnapshot = await db.collection(`users/${userId}/orders`).get();

        if (ordersSnapshot.empty) {
        } else {
          ordersSnapshot.forEach(orderDoc => {
            const orderId = orderDoc.id;
            const orderDetails = orderDoc.data();
            orderData = [...orderData, { userId, orderId, orderDetails }]
          });
        }
      }
      setOrders(orderData)
      setLoading(false)
    } catch (error) {
      console.error("Error fetching orders for all users:", error);
    }

  }

  useEffect(() => {
    getOrders()
  }, [])

  return (
    <div className="container-fluid mt-4 admin_orders">
      <h3 className='py-3'><span>Orders</span><small className='ml-3'>{orders.length}</small><span className='ml-3'>
        {loading ?
          <AutorenewOutlinedIcon className="AutorenewOutlinedIcon" onClick={getOrders} fontSize='' />
          :
          <AutorenewOutlinedIcon onClick={getOrders} fontSize='' />}
      </span></h3>
      <div className="form-group">
        <input type="text" placeholder='Search' className="form-control admin_orders_search" id="usr" /><Button variant='light ml-3' className='mt-0'><FilterAltOutlinedIcon />Filter</Button>
      </div>
      <table>
        <thead>
          <tr>
            <th>ID</th>
            <th>Date</th>
            <th>Status</th>
            <th>Customer</th>
            <th>Payment Method</th>
            <th>Total</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {
            orders.length > 0 &&
            orders.sort((a, b) => {
              let d1 = (a.orderDetails.created)
              let d2 = (b.orderDetails.created)
              return d2 - d1
            }
            ).map((order, id) =>
              <tr key={id}>
                <td>{order.orderId}</td>
                <td style={{ minWidth: '120px' }}>{moment.unix(order.orderDetails.created).format('MMM D YYYY, h:mm a')}</td>
                <td style={{ minWidth: '200px' }}>{order.orderDetails.status ? order.orderDetails.status : 'Pending'}</td>
                <td>{order.userId}</td>
                <td></td>
                <td>
                  <NumericFormat
                    decimalScale={2}
                    value={order.orderDetails.amount / 100}
                    displayType={"text"}
                    thousandSeparator
                    prefix={"₹"}
                    renderText={(value) => (
                      <span className='order__total'>{value}</span>
                    )}
                  />
                </td>
                <td><Link to={`/admin/orders/${order.orderId}`}><EditOutlinedIcon /></Link></td>
              </tr>
            )
          }
        </tbody>
      </table>
    </div>
  )
}

export default AdminOrders
